import { createUseStyles } from 'react-jss'

export const useStyle = createUseStyles({
  description: {
    marginLeft: 8
  }
})
